import { create } from "zustand";

export type DashboardTab = {
  path: string;
  label: string;
};

type DashboardTabsState = {
  tabs: DashboardTab[];
  activeTabPath: string;
  openTab: (tab: DashboardTab, replaceLabel?: boolean) => void;
  closeTab: (path: string) => DashboardTab | null;
  setActiveTab: (path: string) => void;
  updateTabLabel: (path: string, label: string) => void;
};

const normalizePath = (path: string) =>
  path.endsWith("/") && path !== "/" ? path.slice(0, -1) : path;

export const useDashboardTabsStore = create<DashboardTabsState>((set) => ({
  tabs: [],
  activeTabPath: "",

  openTab: (tab, replaceLabel = false) =>
    set((state) => {
      const normalizedPath = normalizePath(tab.path);

      // جلوگیری کامل از باز شدن تب داشبورد
      // if (normalizedPath === "/dashboard") {
      //   return {
      //     ...state,
      //     activeTabPath: ""
      //   };
      // }

      const normalizedTab = {
        ...tab,
        path: normalizedPath
      };

      const isExistingTab = state.tabs.some(
        (currentTab) => normalizePath(currentTab.path) === normalizedPath
      );

      return {
        tabs: isExistingTab
          ? state.tabs.map((currentTab) => {
            if (normalizePath(currentTab.path) !== normalizedPath) {
              return currentTab;
            }

            return replaceLabel
              ? { ...currentTab, label: normalizedTab.label }
              : currentTab;
          })
          : [...state.tabs, normalizedTab],

        activeTabPath: normalizedPath
      };
    }),

  closeTab: (path) => {
    const normalizedPath = normalizePath(path);

    let removedTab: DashboardTab | null = null;

    set((state) => {
      const tabIndex = state.tabs.findIndex(
        (tab) => normalizePath(tab.path) === normalizedPath
      );

      if (tabIndex < 0) {
        return state;
      }

      removedTab = state.tabs[tabIndex];

      const remainingTabs = state.tabs.filter(
        (tab) => normalizePath(tab.path) !== normalizedPath
      );

      const nextActiveTab =
        normalizePath(state.activeTabPath) === normalizedPath
          ? (remainingTabs[tabIndex] ??
            remainingTabs[tabIndex - 1] ??
            remainingTabs[0] ??
            null)
          : (state.tabs.find(
            (tab) =>
              normalizePath(tab.path) === normalizePath(state.activeTabPath)
          ) ?? null);

      return {
        tabs: remainingTabs,
        activeTabPath: nextActiveTab?.path ?? ""
      };
    });

    return removedTab;
  },

  setActiveTab: (path) =>
    set({
      activeTabPath: normalizePath(path)
    }),

  updateTabLabel: (path, label) =>
    set((state) => ({
      tabs: state.tabs.map((tab) =>
        normalizePath(tab.path) === normalizePath(path)
          ? { ...tab, label }
          : tab
      )
    }))
}));